<template>
  <div>
    <a-result
      v-if="currentSystem"
      status="403"
      :sub-title="status[currentSystem.status] || (currentSystem.serviceDeploy <= 2 ? serviceDeployError : '')"
    >
      <template #extra>
        <a-button type="primary" @click="toHome">
          返回首页
        </a-button>
      </template>
    </a-result>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      status: {
        3: '当前系统已停用，不支持查看，请联系您的专属销售经理处理',
        9: '当前系统已废弃，不支持查看，请联系您的专属销售经理处理'
      },
      serviceDeployError: '当前系统正在部署中，不支持查看'
    }
  },
  computed: {
    ...mapGetters([
      'currentSystem'
    ])
  },
  methods: {
    toHome () {
      window.location.href = '/'
    }
  },
  watch: {
    currentSystem: {
      handler: function (val) {
        if (!val) return
        if (!this.status[this.currentSystem.status] && this.currentSystem.serviceDeploy > 2) {
          return this.$router.replace({ path: this.$route.path.slice(0, -4) })
        }
      }
    }
  }
}
</script>
